/**
 * Labstep
 *
 * @module components/FilterPost/NewIndex/Protocol
 * @desc Protocol filter
 */

import { ICONS } from 'labstep-web/constants/icons';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { ModalDefaultContainer as Modal } from 'labstep-web/core/Modal/Default';
import { Protocol } from 'labstep-web/models/protocol.model';
import type React from 'react';
import FilterPostNewIndexProtocolForm from './Form';
import type { FilterPostNewIndexProtocolProps } from './types';

export const FilterPostNewIndexProtocol: React.FC<
  FilterPostNewIndexProtocolProps
> = ({ addPostFilter, ...rest }) => (
  <Modal
    header={`Filter by ${Protocol.getHumanReadableEntityName(false, true)}`}
    viewComponent={({ toggleModal }): React.ReactNode => (
      <ActionComponent
        onClick={toggleModal}
        type="option"
        icon={ICONS.protocol.primary}
        text="Protocol used"
      />
    )}
    content={({ toggleModal }): React.ReactNode => (
      <FilterPostNewIndexProtocolForm
        addPostFilter={addPostFilter}
        onDone={toggleModal}
      />
    )}
    {...rest}
  />
);
